export default {
  badge: 'Jelvény',
  open: 'Megnyit',
  close: 'Bezárás',
  dismiss: 'Elutasít',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Mégsem',
  },
  dataIterator: {
    noResultsText: 'Nincs egyező találat',
    loadingText: 'Betöltés...',
  },
  dataTable: {
    itemsPerPageText: 'Elem oldalanként:',
    ariaLabel: {
      sortDescending: 'Csökkenő sorrendbe rendezve.',
      sortAscending: 'Növekvő sorrendbe rendezve.',
      sortNone: 'Rendezetlen.',
      activateNone: 'Rendezés törlése.',
      activateDescending: 'Aktiváld a csökkenő rendezésért.',
      activateAscending: 'Aktiváld a növekvő rendezésért.',
    },
    sortBy: 'Rendezés',
  },
  dataFooter: {
    itemsPerPageText: 'Elem oldalanként:',
    itemsPerPageAll: 'Mind',
    nextPage: 'Következő oldal',
    prevPage: 'Előző oldal',
    firstPage: 'Első oldal',
    lastPage: 'Utolsó oldal',
    pageText: '{0}-{1} / {2}',
  },
  dateRangeInput: {
    divider: 'to',
  },
  datePicker: {
    itemsSelected: '{0} kiválasztva',
    range: {
      title: 'Válassza ki a dátumokat',
      header: 'Adja meg a dátumokat',
    },
    title: 'Válassza ki a dátumot',
    header: 'Adja meg a dátumot',
    input: {
      placeholder: 'Adja meg a dátumot',
    },
  },
  noDataText: 'Nincs elérhető adat',
  carousel: {
    prev: 'Előző',
    next: 'Következő',
    ariaLabel: {
      delimiter: 'Dia {0}/{1}',
    },
  },
  calendar: {
    moreEvents: '{0} további',
    today: 'Ma',
  },
  input: {
    clear: 'Clear {0}',
    prependAction: '{0} prepended action',
    appendAction: '{0} appended action',
    otp: 'Please enter OTP character {0}',
  },
  fileInput: {
    counter: '{0} fájl',
    counterSize: '{0} fájl ({1} összesen)',
  },
  timePicker: {
    am: 'de',
    pm: 'du',
    title: 'Válassza ki az időpontot',
  },
  pagination: {
    ariaLabel: {
      root: 'Oldal navigáció',
      next: 'Következő oldal',
      previous: 'Előző oldal',
      page: 'Menj a(z) {0}. oldalra',
      currentPage: 'Aktuális oldal: {0}',
      first: 'Első oldal',
      last: 'Utolsó oldal',
    },
  },
  stepper: {
    next: 'Következő',
    prev: 'Előző',
  },
  rating: {
    ariaLabel: {
      item: 'Rating {0} of {1}',
    },
  },
  loading: 'Betöltés...',
  infiniteScroll: {
    loadMore: 'Továbbiak',
    empty: 'Nincsen több',
  },
}
